import { css } from '@emotion/react'

import { zIndex } from '@twisto/styles'

export const errorModal = css`
  z-index: ${zIndex.errorModal};
`
